export default "__VITE_ASSET__efb47bee__";